export default new Uint8Array(0);
